import React, { useEffect, useState } from "react";
import { Table, Spinner, Button, Form } from '@themesberg/react-bootstrap';
import { GetApiRequest } from "../services/api";
import { toast } from '../components/Toaster';

export default () => {
  const [loading, setLoading] = useState(false);
  const [books, setBooks] = useState([]);
  const [pagination, setPagination] = useState({ currentPage: 1, totalPages: 1, totalBooks: 0, limit: 20, hasMore: false });
  const [activeOnly, setActiveOnly] = useState(false);

  const fetchFeatured = async (page, active) => {
    setLoading(true);
    try {
      const res = await GetApiRequest('v1/admin/books/featured', { page, activeOnly: active });
      const data = res?.data?.data || {};
      setBooks(data.books || []);
      setPagination(data.pagination || { currentPage: 1, totalPages: 1, totalBooks: 0, limit: 20, hasMore: false });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Failed to load featured books', e);
      toast.error('Failed to load featured books');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFeatured(pagination.currentPage, activeOnly);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage, activeOnly]);

  return (
    <>
      <div className="mb-3 d-flex align-items-center">
        <Form.Check
          type="switch"
          id="active-only"
          label="Show active only"
          checked={activeOnly}
          onChange={(e) => { setActiveOnly(e.target.checked); setPagination(p => ({ ...p, currentPage: 1 })); }}
          className="me-3"
        />
      </div>

      {loading ? (
        <div className="d-flex justify-content-center my-5"><Spinner animation="border" role="status" /></div>
      ) : (
        <Table responsive hover className="table-centered table-nowrap rounded mb-4">
          <thead className="thead-light">
            <tr>
              <th>Book ID</th>
              <th>Cover</th>
              <th>Title</th>
              <th>Author</th>
              <th>Priority</th>
              <th>Active</th>
              <th>Description</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {books.map(b => (
              <tr key={b._id}>
                <td>{b.bookId}</td>
                <td>{b.bookCover ? <img src={b.bookCover} alt={b.bookTitle} style={{ width: 40, height: 60, objectFit: 'cover' }} /> : '-'}</td>
                <td>{b.bookTitle}</td>
                <td>{b.bookAuthor}</td>
                <td>{b.priority}</td>
                <td>{b.isActive ? 'Yes' : 'No'}</td>
                <td>{b.description}</td>
                <td>{new Date(b.createdAt).toLocaleDateString()}</td>
              </tr>
            ))}
            {books.length === 0 && (
              <tr><td colSpan={8} className="text-center text-muted">No featured books</td></tr>
            )}
          </tbody>
        </Table>
      )}

      <div className="d-flex justify-content-between align-items-center">
        <div className="small text-muted">Total: {pagination.totalBooks}</div>
        <div>
          <Button size="sm" variant="outline-primary" className="me-2" disabled={pagination.currentPage <= 1} onClick={() => setPagination(p => ({ ...p, currentPage: Math.max(1, p.currentPage - 1) }))}>Prev</Button>
          <span className="small me-2">Page {pagination.currentPage} of {pagination.totalPages}</span>
          <Button size="sm" variant="outline-primary" disabled={pagination.currentPage >= pagination.totalPages} onClick={() => setPagination(p => ({ ...p, currentPage: p.currentPage + 1 }))}>Next</Button>
        </div>
      </div>
    </>
  );
};


